<template>
  <CommonPopup
    v-model="visible"
    title="换肤"
    height="70%"
    position="bottom"
    round
    class="result_theme_picker"
    :show-footer="false"
    @click-overlay="onCancel"
  >
    <header slot="title" class="result_theme_header">
      <span class="default_theme" @click="useDefaultTheme">使用默认</span>
      <span class="title">换肤</span>
      <span
        class="confirm"
        data-stat-id="theme_picker_confirm"
        :data-stat-ep="JSON.stringify({
          theme: currentThemeItem && currentThemeItem.key,
        })"
        @click="onConfirm"
      >确定</span>
    </header>
    <section class="result_theme_main">
      <div class="category_list">
        <div class="category_list_wrapper">
          <div
            v-for="(item, i) in themeCategoryList"
            :key="item.type"
            class="category_item"
            :class="{
              active: currentCategoryId === item.type,
              prev: i === themeCategoryList.findIndex(e => e.type === currentCategoryId) - 1,
              next: i === themeCategoryList.findIndex(e => e.type === currentCategoryId) + 1,
            }"
            @click="currentCategoryId = item.type"
          >
            <span class="name">{{ item.name }}</span>
            <span v-if="item.type !== 0 && !isBaoXiaoZhuTenant" class="vip">会员</span>
          </div>
        </div>
      </div>
      <div class="theme_list">
        <div
          v-for="category in themeCategoryList.map(e => e.type)"
          v-show="category === currentCategoryId"
          :key="category"
          class="theme_list_wrapper"
        >
          <div
            v-for="item in themeMap[category]"
            :key="item.id"
            class="theme_item"
            :class="{
              [item.id]: true,
              active: currentThemeId === item.id,
            }"
            @click="onChange(item)"
          >
            <div class="image">
              <img :src="item.bannerImage + '?x-oss-process=image/resize,w_200'" alt="theme">
            </div>
            <div class="name">
              <span>{{ item.name }}</span>
            </div>
            <div class="iconfont" :class="[item.collect ? 'active' : '']" @click.stop="onCollect(item)">
              <van-icon :name="item.collect ? 'star' : 'star-o'" />
            </div>
          </div>
        </div>
        <van-empty
          v-if="currentCategoryId === 0 && themeMap[0] && !themeMap[0].length"
          image="https://media.winbaoxian.com/autoUpload/common/error-empty_71d507cd6a90807.png"
          description="暂无收藏主题"
        />
      </div>
    </section>
  </CommonPopup>
</template>
<script>
import { Toast } from 'vant';
import qs from 'qs';
import { get as _get } from 'lodash';
import { isBaoXiaoZhuTenant, getUrlParams } from '@/common/utils';
import { saveSkinCollect } from '@/api/theme.js';
import CommonPopup from '@/components/common/common-popup/index.vue'

const SKIN_TYPE_MAP = {
  0: '收藏',
  1: '储蓄',
  2: '养老',
  7: '人生阶段',
  3: '孩子',
  4: '女性',
  5: '男性',
  10: '人群',
  8: '税优',
  6: '节日',
  9: '节气'
}
const SKIN_TYPE_ORDER = [0, 1, 2, 7, 3, 4, 5, 10, 8, 6, 9]

export default {
  components: {
    CommonPopup
  },
  props: {
    value: Boolean,
    columns: {
      type: Array,
      default: () => []
    },
    defaultTheme: String,
    previewTheme: String,
  },
  data () {
    return {
      currentCategoryId: 0,
      currentThemeId: null,
      isBaoXiaoZhuTenant
    }
  },
  computed: {
    visible: {
      get () {
        const themeItem = (this.columns || []).find(e => e.key === this.previewTheme);
        if (themeItem) {
          this.currentCategoryId = themeItem.skinType
          this.currentThemeId = themeItem.id
        }
        return !!this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    themeCategoryList () {
      const { columns } = this
      // 默认为储蓄类型
      const categoryTypes = (columns || [])
        .map(e => e.skinType || 1)
        .filter((e, i, arr) => arr.indexOf(e) === i)
        .sort((a, b) => {
          const indexA = SKIN_TYPE_ORDER.indexOf(a)
          const indexB = SKIN_TYPE_ORDER.indexOf(b)
          if (indexA === -1 && indexB === -1) return a - b
          if (indexA === -1) return 1
          if (indexB === -1) return -1
          return indexA - indexB
        })
      categoryTypes.unshift(0)
      const categories = categoryTypes.map(t => ({
        type: t,
        name: SKIN_TYPE_MAP[t] || '其他',
      }))
      return categories
    },
    themeMap () {
      return (this.themeCategoryList || []).reduce((acc, item) => {
        if (item.type === 0) {
          acc[item.type] = this.columns.filter(e => e.collect);
        } else {
          acc[item.type] = this.columns.filter(e => e.skinType === item.type);
        }
        return acc;
      }, {});
    },
    currentThemeItem () {
      return (this.columns || []).find(e => e.id === this.currentThemeId)
    },
    defaultThemeItem () {
      const { columns, defaultTheme } = this
      const list = columns || []
      if (!list.length) return null
      const exact = list.find(e => e.key === defaultTheme)
      // 默认皮肤找不到时，退化为皮肤列表中的第一个皮肤
      return exact || list[0]
    }
  },
  methods: {
    useDefaultTheme () {
      const { defaultThemeItem } = this;  
      if (defaultThemeItem) {
        this.currentCategoryId = defaultThemeItem.skinType
        this.currentThemeId = defaultThemeItem.id
        this.$emit('change', defaultThemeItem.key)
      }
    },
    onChange (item) {
      this.currentThemeId = item.id;
      this.$emit('change', item.key);
    },
    onCollect (item) {
      item.collect = !item.collect;
      return saveSkinCollect({
        skinId: item.id,
      }).then(() => {
        this.columns.forEach(e => {
          if (e.id === item.id) {
            e.collect = item.collect;
          }
        });
        Toast.success(item.collect ? '收藏成功' : '已取消收藏')
      })
    },
    onConfirm () {
      const { currentThemeId, defaultThemeItem } = this;
      const defaultThemeId = _get(defaultThemeItem, 'id');
      if (currentThemeId === defaultThemeId) {
        this.setThemeToUrl(currentThemeId)
        return;
      }
      if (window.memberSwitchPop) {
        window.memberSwitchPop({
          businessId: 'planbook_result_theme',
          checkFreeTimes: true,
          ljSource: {
            1: 'jhsjgy',
            3: 'jhsjgy_lj_sj',
          },
          normalBack: () => {
            this.setThemeToUrl(currentThemeId)
          }
        });
      }
    },
    setThemeToUrl (themeId) {
      const themeItem = this.columns.find(e => e.id === themeId);
      if (themeItem) {
        const params = getUrlParams();
        params.theme = themeItem.key;
        const url = location.origin + location.pathname + `?${qs.stringify(params)}`;
        if (window.history && typeof window.history.replaceState === "function") {
          window.history.replaceState(null, '', url);
        }
      }
      this.visible = false
    },
    onCancel () {
      this.visible = false
      this.$emit('change');
    }
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>